const testimonials = [
  {
    name: 'Marcus T.',
    role: 'Product Designer',
    avatar: 'https://public.readdy.ai/ai/img_res/c2b61d46619aa113ae6eff3559e9ee14.jpg',
    quote: 'These guys are absolute legends. I sent them a rough sketch and they turned it into a perfect prototype in 48 hours. The quality blew me away.',
    stars: 5,
  },
  {
    name: 'Sarah K.',
    role: 'Tabletop Game Creator',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20young%20woman%20game%20designer%2C%20friendly%20smile%2C%20creative%20studio%20background%2C%20natural%20lighting%2C%20portrait%20photography&width=100&height=100&seq=avatar-002&orientation=squarish',
    quote: 'I needed 50 custom miniatures for my Kickstarter campaign. Reader Brothers delivered every single one with insane detail. My backers are obsessed!',
    stars: 5,
  },
  {
    name: 'James R.',
    role: 'Home Renovator',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20middle-aged%20man%20contractor%2C%20friendly%20confident%20smile%2C%20workshop%20background%2C%20natural%20lighting%2C%20portrait%20photography&width=100&height=100&seq=avatar-003&orientation=squarish',
    quote: 'Needed a replacement bracket for an old appliance — couldn\'t find it anywhere. They designed and printed it in a day. Saved me hundreds of dollars.',
    stars: 5,
  },
  {
    name: 'Priya M.',
    role: 'Interior Designer',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20young%20woman%20interior%20designer%2C%20warm%20smile%2C%20modern%20office%20background%2C%20soft%20lighting%2C%20portrait%20photography&width=100&height=100&seq=avatar-004&orientation=squarish',
    quote: 'Ordered custom geometric vases for a client project. The finish was flawless and they matched the color palette perfectly. Will definitely order again.',
    stars: 5,
  },
  {
    name: 'Derek L.',
    role: 'Cosplay Artist',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20young%20man%20cosplay%20artist%2C%20enthusiastic%20smile%2C%20creative%20workshop%20background%2C%20dramatic%20lighting%2C%20portrait%20photography&width=100&height=100&seq=avatar-005&orientation=squarish',
    quote: 'My armor set came out better than I imagined. The brothers really care about the craft — they even suggested improvements to my design. 10/10.',
    stars: 5,
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-1">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-orange-400 text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="py-24 px-6 md:px-10 bg-gradient-to-br from-fuchsia-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-[3px] font-bold bg-gradient-to-r from-fuchsia-500 to-cyan-500 bg-clip-text text-transparent">
            Client Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mt-3">What Our Clients Say</h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 flex flex-col gap-4"
              style={{ border: '1px solid #f0f0f0' }}
            >
              <StarRating count={t.stars} />
              <p className="text-gray-700 text-sm leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
